<template>
  <div class="supply-container">
    <div class="development-notice">
      开发中......
    </div>
  </div>
</template>

<script>
export default {
  name: 'SupplyView'
}
</script>

<style scoped>
.supply-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #e4e8eb 100%);
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.development-notice {
  font-size: 48px;
  color: #2c3e50;
  padding: 80px;
  background: white;
  border-radius: 20px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
  text-align: center;
  animation: fadeIn 0.5s ease;
  width: 50vw;
  min-width: 300px;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>